(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lambert-ai-footnote"] && !Shopify.designMode) return;
  try {
    function followAiFootnote(event) {
    const marker = event.target.closest?.('.lambert-ai-label[role="link"]');
    if (!marker || (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelector('dialog[open]')?.close();
    const explanation = document.getElementById('lambert-ai-explanation');
    explanation?.scrollIntoView({ block: 'center' });
    explanation?.focus({ preventScroll: true });
  }
  window.addEventListener('click', followAiFootnote, true);
  window.addEventListener('keydown', followAiFootnote, true);
  } catch(e) { console.error(e); }
})();

})();
